// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /message-request/list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeMessageRequestListBody,
  typeMessageRequestListOutput200,
} from "../../sdk/messageRequest/postMessageRequestList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildMessageRequestListQueryKey(
  payload: typeMessageRequestListBody,
): string[] {
  const queryKeySegments: string[] = [];
  if (typeof payload.cursor !== "undefined") {
    queryKeySegments.push(`cursor:${JSON.stringify(payload.cursor)}`);
  }
  if (typeof payload.limit !== "undefined") {
    queryKeySegments.push(`limit:${JSON.stringify(payload.limit)}`);
  }
  return [
    "post:messageRequest:messageRequestList",
    "svc:messaging-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeMessageRequestListOutput200,
    unknown,
    typeMessageRequestListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useMessageRequestList(
  payload: typeMessageRequestListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildMessageRequestListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postMessageRequestList(payload),
    ...resolvedOptions,
  });
}
